export default "__VITE_ASSET__0I1kJLaO__"